import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettMultimedia } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxSettMultimediaForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  let r_form = React.useRef(null);

  const [storeSettMultimedia, setStoreSettMultimedia] = useSessionStorage('StoreSettMultimedia', StoreSettMultimedia);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
    } else {
      storeSettMultimedia.itMultimedia = lastSaveRv.theValue;
      Promise.all([setStoreSettMultimedia(storeSettMultimedia)]).then((result) => {
        navBack();
      });
    }
  }
  const formDelete = async (rv) => {
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.type')} - ${trans('field.multimedia_file')}`}
        xref={r_form}
        url="sett/multimedia" 
        filterIdField='itMultimedia'
        filterIdValue={storeSettMultimedia.itMultimedia} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="t_multimedia.itMultimedia" value={storeSettMultimedia.itMultimedia || ''} />
        <CxInput xref={useRef(null)} label={`${trans('field.type')} - ${trans('field.multimedia_file')}`} dbfield="t_multimedia.txTypeMultimedia" required />
        
      </GxForm>

    </div>
  );

}

export default MxSettMultimediaForm;
